export default __webpack_public_path__ + "static/media/twitter.a91f33be.svg";